// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__27POm","vLegacy":"SelectSecondary_vLegacy__vUnXk","error":"SelectSecondary_error__3H3uI","disabled":"SelectSecondary_disabled__AKZ3W"};